import classnames from 'classnames';

import './QuestionMarkIcon.css';

interface QuestionMarkIconProps {
  className?: string;
  size?: number;
}

/**
 * Question mark help icon. Uses currentColor for CSS-driven fills.
 */
function QuestionMarkIcon({ className, size = 24 }: QuestionMarkIconProps) {
  return (
    <svg
      aria-hidden='true'
      className={classnames('question-mark-icon', className)}
      fill='none'
      focusable='false'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.0234 24C7.71094 24 3.77344 21.75 1.61719 18C-0.539062 14.2969 -0.539062 9.75 1.61719 6C3.77344 2.29688 7.71094 0 12.0234 0C16.2891 0 20.2266 2.29688 22.3828 6C24.5391 9.75 24.5391 14.2969 22.3828 18C20.2266 21.75 16.2891 24 12.0234 24ZM7.94531 7.78125V7.82812C7.75781 8.39062 8.03906 9.04688 8.64844 9.28125C9.21094 9.46875 9.86719 9.1875 10.0547 8.57812L10.1016 8.53125C10.1484 8.39062 10.2891 8.29688 10.4297 8.29688H13.1484C13.5703 8.29688 13.8984 8.57812 13.8984 9C13.8984 9.23438 13.7578 9.46875 13.5234 9.60938L11.4609 10.7812C11.0859 10.9688 10.8984 11.3438 10.8984 11.7656V12.375C10.8984 13.0312 11.3672 13.5 12.0234 13.5C12.6328 13.5 13.1016 13.0312 13.1484 12.4219L14.6484 11.5312C15.5391 11.0156 16.1484 10.0312 16.1484 9C16.1484 7.35938 14.7891 6 13.1484 6H10.4297C9.30469 6 8.32031 6.70312 7.94531 7.78125ZM10.5234 16.5C10.5234 17.3438 11.1797 18 12.0234 18C12.8203 18 13.5234 17.3438 13.5234 16.5C13.5234 15.7031 12.8203 15 12.0234 15C11.1797 15 10.5234 15.7031 10.5234 16.5Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default QuestionMarkIcon;
